import { motion } from "framer-motion";
import { IndianRupee } from "lucide-react";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/api";

export default function CouponOffer() {
  return (
    <section className="py-16 sm:py-28 px-5 lg:px-8 bg-white" data-testid="coupon-offer-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative bg-[#0A0A0A] rounded-sm p-8 sm:p-14 overflow-hidden text-white"
        >
          <div className="absolute -top-12 -right-12 w-56 h-56 rounded-full bg-[#FF5A00]/15 blur-3xl" />
          <div className="flex items-center gap-3 mb-4">
            <IndianRupee className="w-7 h-7 text-[#FF5A00]" />
            <p className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold">Cashback in Coupons</p>
          </div>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight max-w-2xl">
            Your Money Comes Back at <span className="text-[#FF5A00]">AutoHQ.</span>
          </h2>
          <p className="mt-5 text-neutral-400 max-w-2xl leading-relaxed">
            Service your car and receive a coupon kit equal to your full bill
            value — redeemable on future visits. Pay ₹5,000 today, get ₹5,000
            back in coupons.
          </p>
          <Button
            data-testid="coupon-whatsapp-cta"
            asChild
            className="mt-8 bg-[#FF5A00] hover:bg-[#E04F00] text-white font-bold px-6 py-5 rounded-sm"
          >
            <a href={waLink("Hi AutoHQ! Tell me more about the full bill value coupon kit offer.")} target="_blank" rel="noopener noreferrer">
              Know More on WhatsApp
            </a>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
